import { createFileRoute, Link, useParams } from '@tanstack/react-router'
import { ChevronRight } from 'lucide-react'
import {
  RunbookRunContent,
  RunbookRunHeaderActions,
} from '@/components/compliance/RunbookRunDetail'
import { ScreenataPageLayout } from '@/components/compliance/ScreenataPageLayout'

const BREADCRUMB_LINK_CLASS =
  'text-[13px] font-medium text-text-subtle transition-colors hover:text-text-secondary'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/runs/$executionId'
)({
  component: ExecutionRunPage,
})

function ExecutionRunPage() {
  const { executionId, workspaceId } = useParams({ strict: false }) as {
    executionId: string
    workspaceId: string
  }

  return (
    <ScreenataPageLayout
      title='Log Details'
      breadcrumb={
        <>
          <Link
            to='/workspaces/$workspaceId/runbooks'
            params={{ workspaceId }}
            search={{ tab: 'catalog' }}
            className={BREADCRUMB_LINK_CLASS}
          >
            Procedures
          </Link>
          <ChevronRight
            className='h-3.5 w-3.5 shrink-0 text-text-placeholder'
            aria-hidden
          />
          <Link
            to='/workspaces/$workspaceId/runbooks'
            params={{ workspaceId }}
            search={{ tab: 'logs' }}
            className={BREADCRUMB_LINK_CLASS}
          >
            Logs
          </Link>
        </>
      }
      headerActions={<RunbookRunHeaderActions runId={executionId} />}
      scroll
      raw
    >
      <div className='mx-auto w-full max-w-[1120px] p-6'>
        <div className='overflow-hidden rounded-sm border border-border bg-card'>
          <RunbookRunContent runId={executionId} layout='page' />
        </div>
      </div>
    </ScreenataPageLayout>
  )
}
